import type { Novidade } from './tipos';

/** Portal do Cliente (Onda 1): o lado da equipe (convite, documentos, mensagens e "Ver como o cliente"). */
export const novidadePortal: Novidade = {
  id: '2026-10-05-portal',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'portal',
  permissao: 'portal.ver',
  rota: '/comercial/portal/acessos',
  textos: {
    pt: {
      titulo: 'Portal do cliente: o app "Malgo" para os seus clientes',
      resumo: 'O cliente vê faturas, Pix e boletos, recebe e envia documentos e conversa com a equipe, no celular ou no computador.',
      passos: [
        'Em Comercial > Portal do cliente > Configuração do portal, publique o termo de uso: sem ele, o convite não sai.',
        'Na ficha do cliente, o cartão Portal do cliente convida uma pessoa por e-mail, com o papel dela (Dono, Financeiro, DP e outros).',
        'Publique documentos no mesmo cartão; o que o cliente envia aparece em Recebidos, e a Trilha mostra cada acesso e download.',
        'As mensagens do cliente chegam em Conversas > Portal; a resposta volta para o app dele na hora.',
        'Ver como o cliente abre o portal dele só para leitura, com registro na auditoria.',
      ],
    },
    en: {
      titulo: 'Client portal: the "Malgo" app for your clients',
      resumo: 'Clients see invoices, Pix and bank slips, receive and send documents and talk to the team, on the phone or the computer.',
      passos: [
        'In Sales > Client portal > Portal settings, publish the terms of use: without them, no invitation goes out.',
        'On the client record, the Client portal card invites a person by e-mail, with their role (Owner, Finance, Payroll and HR and others).',
        'Publish documents on the same card; what the client sends shows in Received, and the Audit trail shows each access and download.',
        'Client messages arrive in Conversations > Portal; the reply reaches their app right away.',
        'View as the client opens their portal read-only, recorded in the audit log.',
      ],
    },
    es: {
      titulo: 'Portal del cliente: la app "Malgo" para tus clientes',
      resumo: 'El cliente ve facturas, Pix y boletos, recibe y envía documentos y habla con el equipo, en el celular o la computadora.',
      passos: [
        'En Comercial > Portal del cliente > Configuración del portal, publica los términos de uso: sin ellos, la invitación no sale.',
        'En la ficha del cliente, la tarjeta Portal del cliente invita a una persona por correo, con su rol (Dueño, Finanzas, Personal y nómina y otros).',
        'Publica documentos en la misma tarjeta; lo que el cliente envía aparece en Recibidos, y el Registro muestra cada acceso y descarga.',
        'Los mensajes del cliente llegan a Conversaciones > Portal; la respuesta vuelve a su app al instante.',
        'Ver como el cliente abre su portal solo para lectura, con registro en la auditoría.',
      ],
    },
  },
  imagens: [null, '/novidades/2026-10-05-portal/cartao.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
